import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
  paddingBox: {
    padding: '12px'
  }
}));
